import { ModalContent, ModalFooter } from '@components/modal';
import ReadOnlyMap from '@components/map/readOnlyMap';
import { calculateGeometryExtent } from '@src/utils/helpers';
import { useProjectLocation } from '@api/services/project/useProjects';
import ModalLoader from '@components/loader/ModalLoader';

import { useRequest } from '@stores';
import ProjectLocationSummary from '@components/project-location/ProjectLocationSummary';

const ProjectLocationModal = ({ locationData, projectId, saveText = 'Close', version }) => {
  const { selectedRequestId } = useRequest();
  const { data: projectData, isLoading } = useProjectLocation({ projectId, version, hasLocationData: !!locationData });
  const location = locationData || projectData?.location;
  const modalTitle = selectedRequestId === '6' ? 'Site Location' : 'Project Location';

  if (isLoading) {
    return <ModalLoader title={modalTitle} />;
  }

  return (
    <ModalContent hasCloseButton title={modalTitle}>
      <section className='modal-body'>
        <ReadOnlyMap mapOnly geometry={location?.geometry} extent={calculateGeometryExtent(location?.geometry)} />
        <ProjectLocationSummary className='margin-top-1' summaryData={location} />
      </section>
      <ModalFooter saveText={saveText} showCancelButton={false} />
    </ModalContent>
  );
};
export default ProjectLocationModal;
